
import { home as homeDE } from './de/home';
import { about as aboutDE } from './de/about';
import { structure as structureDE } from './de/structure';
import { contact as contactDE } from './de/contact';
import { common as commonDE } from './de/common';

import { home as homeEN } from './en/home';
import { about as aboutEN } from './en/about';
import { structure as structureEN } from './en/structure';
import { contact as contactEN } from './en/contact';
import { common as commonEN } from './en/common';

import { home as homeES } from './es/home';
import { about as aboutES } from './es/about';
import { structure as structureES } from './es/structure';
import { contact as contactES } from './es/contact';
import { common as commonES } from './es/common';

export const resources = {
  de: {
    home: homeDE,
    about: aboutDE,
    structure: structureDE,
    contact: contactDE,
    common: commonDE
  },
  en: {
    home: homeEN,
    about: aboutEN,
    structure: structureEN,
    contact: contactEN,
    common: commonEN
  },
  es: {
    home: homeES,
    about: aboutES,
    structure: structureES,
    contact: contactES,
    common: commonES
  }
};
